import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavLinks } from "../../../types/navLinks";

type MainLinkTypes = {
  path: string;
  slug: string;
  title: string;
  innerLinks?: NavLinks[];
};

function MainLink({ path, slug, title, innerLinks }: MainLinkTypes) {
  // location and pathSlug will be used to add active state styles on nav link
  const location = useLocation();

  const pathSlug = location.pathname.split("/")[2];

  const [showSubMenu, setShowSubMenu] = useState<boolean>(false);

  const toggleSubmenu = () => {
    setShowSubMenu((prevState) => !prevState);
  };

  return (
    <>
      {innerLinks!.length === 0 && (
        <Link
          to={path}
          className={`w-full min-h-11 py-2.5 px-3.5 flex justify-start items-center rounded-md relative text-base leading-tight ${
            pathSlug === slug
              ? "font-semibold shadow-md bg-blue text-white"
              : "bg-white shadow-md"
          }`}
        >
          <span className="w-full text-left break-words">{title}</span>
        </Link>
      )}

      {innerLinks!.length > 0 && (
        <button
          onClick={toggleSubmenu}
          className={`w-full min-h-11 py-2.5 px-3.5 flex justify-start items-center rounded-md relative text-base leading-tight ${
            innerLinks?.some((link) => link.path === location.pathname) ||
            showSubMenu
              ? "font-semibold shadow-md bg-blue text-white"
              : "bg-white shadow-md"
          }`}
        >
          <span className="w-full text-left break-words pr-6">{title}</span>
          {showSubMenu && (
            <div className="absolute z-50 right-0 top-11 shadow-md rounded-md h-fit w-full p-3 flex justify-center items-center flex-col bg-light-light-grey">
              {innerLinks!.map((innerLink) => (
                <Link
                  key={innerLink.slug}
                  to={innerLink.path}
                  className={`w-full min-h-11 py-2.5 px-3.5 flex mb-1 justify-start items-center rounded-md text-grey text-base leading-tight relative ${
                    location.pathname === innerLink.path
                      ? "font-semibold shadow-md bg-blue text-white"
                      : "bg-white"
                  }`}
                >
                  <span className="w-full text-left break-words">{innerLink.label}</span>
                </Link>
              ))}
            </div>
          )}
        </button>
      )}
    </>
  );
}

export default MainLink;
